import React from 'react';
import "./Navs.scss";

interface IMenuNavs extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: any,
    onClick: any,
    active?: boolean,
}

function MenuNav({ active, children, onClick, ...props }: IMenuNavs) {

    return (
        <div className={`MenuNavs ${active && "current"}`} onClick={onClick} {...props}>
            {children}
        </div>
    )
}

export default MenuNav